<template>
  <div class="pioneer6-accessories-section">
    <div class="header-content">
      <h1 class="feature-header">{{ sectionData.field_2 }}</h1>
      <!-- <h1 class="feature-subheader">{{ sectionData.field_5 }}</h1> -->
    </div>

    <div class="slider-container">
      <div class="slider">
        <div class="slide" v-for="(product, index) in currentProducts" :key="index">
          <img class="product-img" :src="product.defaultImage" alt="">
          <div class="slide-content">
            <a class="product-stockCode" :href="'/product/' + product.stockCode"> {{ product.stockCode }}</a>
            <a class="product-title" :href="'/product/' + product.stockCode">{{ product.title }}</a>
            <a v-if="product.copy" class="product-stockCode" :href="'/product/' + product.stockCode"> {{ product.copy }}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="slider-controls">
      <div v-if="totalSlides > 1">
        <ul class="controls">
          <li @click="prevSlide" data-type="prev"></li>
          <li data-type="step" v-for="(slide, index) in totalSlides" :key="index"
            :class="index === currentSlide ? 'active' : ''" @click="goToSlide(index)"></li>
          <li @click="nextSlide" data-type="next"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pioneer6-accessories",
  props: {
    section: {
      type: String,
      required: true,
    },
    productdata: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sectionData: {
        items: [],
      },
      products: [],
      productCount: 0,
      currentSlide: 0,
      slideCount: this.calculateSlideCount(),
    };
  },
  beforeDestroy() {
    // Remove the resize event listener to avoid memory leaks
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    totalSlides() {
      return Math.ceil(this.products.length / this.slideCount);
    },
    currentProducts() {
      const start = this.currentSlide * this.slideCount;
      const end = start + this.slideCount;
      return this.products.slice(start, end);
    },
  },
  mounted() {
    try {
      this.products = JSON.parse(this.productdata);
      this.sectionData = JSON.parse(this.section);
      window.addEventListener('resize', this.handleResize);
    } catch (error) {
      console.error("Error parsing section JSON:", error);
    }
  },
  methods: {
    handleResize() {
      this.slideCount = this.calculateSlideCount();
    },
    calculateSlideCount() {
      if (window.innerWidth >= 1200) {
        return 8;
      }
      else if (window.innerWidth >= 961) {
        return 8;
      }
      else if (window.innerWidth >= 768) {
        return 4;
      }
      else {
        return 2;
      }
    },
    handleResize() {
      // Update the slideCount when the window is resized
      this.slideCount = this.calculateSlideCount();
    },
    prevSlide() {
      // Ensure that the current slide does not go below 0
      this.currentSlide = Math.max(this.currentSlide - 1, 0);
    },
    nextSlide() {
      // Ensure that the current slide does not go beyond the total number of slides
      this.currentSlide = Math.min(this.currentSlide + 1, this.totalSlides - 1);
    },
    goToSlide(index) {
      // Navigate to the clicked slide
      this.currentSlide = index;
    },
  },
};
</script>


<style lang="scss" scoped>
.pioneer6-accessories-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  overflow-x: scroll;
  padding: 90px 0 40px 0;

  &::-webkit-scrollbar {
    display: none;
  }

  .header-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;

    .feature-header {
      color: #000000;
      font-family: "trim-medium";
      font-size: 32px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 39px;
      text-align: center;
      max-width: 60%;

      @media only screen and (max-width: 767px) {
        max-width: 95%;
        font-size: 24px;
      }
    }

    .feature-subheader {
      color: #0F1720;
      font-family: 'trim-light';
      font-size: 18px;
      font-weight: 300;
      letter-spacing: 0.35px;
      line-height: 22px;
      text-align: center;
    }
  }

  .slider-container {
    display: flex;
    justify-content: center;
    align-items: center;

    .slider {
      display: flex;
      transition: transform 0.5s;
      flex-wrap: wrap;
      gap: 20px;
      width: 100%;
      max-width: 1200px;
    }

    .slide {
      width: calc(25% - 15px);
      @media only screen and (max-width: 767px) {
        width: calc(50% - 10px);
      }
      background: white;

      .product-img {
        width: 100%;
        object-fit: contain;
      }

      .slide-content {
        display: flex;
        flex-direction: column;
        padding: 25px 15px;
        gap: 10px;

        .product-stockCode {
          color: #000000;
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 0.89px;
          line-height: 19px;
          text-align: center;
          padding-top: 24px;
          text-decoration: none;
        }

        .product-title {
          color: #005CB9;
          font-family: "trim-medium";
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 0.89px;
          line-height: 19px;
          text-align: center;
          text-decoration: none;
        }

      }

    }
  }



  .slider-controls {
    .controls {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 2rem;
      padding-left: 0;
      flex-wrap: wrap;

      li {
        list-style-type: none;
        height: .8rem;
        width: .8rem;
        background-color: #D8D8D8;
        margin: .4rem;
        cursor: pointer;

        &.active {
          background-color: #005CB9;
        }

        &:first-child {
          background-color: transparent;
          border: solid #353535;
          border-width: 0 3px 3px 0;
          display: inline-block;
          width: 1rem;
          height: 1rem;
          transform: rotate(135deg);
          margin-right: 1rem;
        }

        &:last-child {
          background-color: transparent;
          border: solid #353535;
          border-width: 0 3px 3px 0;
          display: inline-block;
          width: 1rem;
          height: 1rem;
          transform: rotate(-45deg);
          margin-left: 1rem;
        }
      }
    }
  }
}
</style>
